import React from 'react'
import {IconProps, IconWrapper} from './IconWrapper'

const renderIcon = (color: string = "#37373E") => (
    <path
        d="M10 10L14 14M6.66667 11.3333C4.08934 11.3333 2 9.244 2 6.66667C2 4.08934 4.08934 2 6.66667 2C9.244 2 11.3333 4.08934 11.3333 6.66667C11.3333 9.244 9.244 11.3333 6.66667 11.3333Z"
        stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
)

export const Search: React.FC<IconProps> = ({color, size}) =>
    <IconWrapper {...{size, color, renderIcon}} viewBox={`0 0 ${parseInt(size)} ${parseInt(size)}`}/>
